import React from "react";
import { Button } from "./ui/button";

const PurchaseOptions = () => {
  const purchaseLinks = [
    {
      platform: "Amazon Kindle",
      price: "R$ 19,90",
      link: "https://www.amazon.com.br/Vida-Jesus-Evangelho-Prosperidade-Eternidade-ebook/dp/B0FDC5L47T",
      type: "digital"
    },
    {
      platform: "Amazon Físico", 
      price: "R$ 39,90",
      link: "https://www.amazon.com.br/Vida-Jesus-Evangelho-Prosperidade-Eterna/dp/B0F28CR9RW",
      type: "physical"
    },
    {
      platform: "UICLAP Digital",
      price: "R$ 18,90",
      link: "https://loja.uiclap.com/titulo/ua101311/?srsltid=AfmBOoo5RMcuGIkMwttiHX86ZGMr7oTZIIIJNMkzka8El1Mob1sJu5lp",
      type: "digital"
    },
    {
      platform: "UICLAP Físico",
      price: "R$ 35,90", 
      link: "https://loja.uiclap.com/titulo/ua68103/",
      type: "physical"
    }
  ];

  const handleWhatsApp = () => {
    const message = encodeURIComponent("Olá! Tenho interesse no livro 'A Vida de Jesus: O Evangelho da Prosperidade Eterna'. Gostaria de mais informações.");
    window.open(`https://wa.me/5521986402130?text=${message}`, '_blank');
  };

  return (
    <section id="purchase-section" className="py-20 px-6 bg-gradient-to-br from-red-50 to-red-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-8">
          Quanto custa ter acesso a esta transformação?
        </h2>

        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">
            ⚠️ ⚠️ ⚠️ ONDE VOCÊ PODE ADQUIRIR O LIVRO:
          </h3>

          {/* Book cover */}
          <div className="flex justify-center mb-8">
            <div className="bg-white p-4 rounded-lg shadow-xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_jesus-livro/artifacts/76tchu9v_ua68103.jpg" 
                alt="Capa do livro A Vida de Jesus - O Evangelho da Prosperidade Eterna"
                className="w-auto h-80 object-contain rounded-lg"
                style={{ maxWidth: '300px' }}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {purchaseLinks.map((option, index) => (
              <div key={index} className="border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-green-600 text-2xl">✓</span>
                  <span className={`px-3 py-1 rounded-full text-sm ${
                    option.type === 'digital' 
                      ? 'bg-blue-100 text-blue-800' 
                      : 'bg-orange-100 text-orange-800'
                  }`}>
                    {option.type === 'digital' ? '📱 Digital' : '📚 Físico'}
                  </span>
                </div>
                <h4 className="font-bold text-lg mb-2">{option.platform}</h4>
                <p className="text-2xl font-bold text-red-600 mb-4">{option.price}</p>
                <Button 
                  onClick={() => window.open(option.link, '_blank')}
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg transition-colors"
                >
                  Comprar Agora
                </Button>
              </div>
            ))}
          </div>
        </div>

        {/* Why this price section */}
        <div className="bg-white rounded-xl p-8 mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            Por que um investimento tão acessível, se é uma transformação tão profunda?
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Porque eu não estou escrevendo este livro apenas por dinheiro. Minha missão é maior que isso. Eu estou fazendo isso para que, daqui a alguns meses, você volte aqui e me conte o seu testemunho de transformação.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Quero ouvir você dizendo como foi experienciar a jornada ao lado de Jesus, como foi sentir a presença d'Ele transformando sua vida, como foi descobrir a verdadeira prosperidade eterna.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            <strong>Essa é a concretização da minha missão agora. Quando eu ajudo alguém a conhecer Jesus de forma profunda e transformadora, eu ajudo uma vida a encontrar propósito eterno. Isso, pra mim, não tem preço.</strong>
          </p>
        </div>

        {/* WhatsApp Contact */}
        <div className="bg-green-50 border border-green-200 rounded-xl p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            Tem alguma dúvida? Fale diretamente conosco!
          </h3>
          <Button 
            onClick={handleWhatsApp}
            className="bg-green-600 hover:bg-green-700 text-white py-4 px-8 rounded-lg text-lg"
          >
            📱 WhatsApp: (21) 98640-2130
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PurchaseOptions;